import React, { useRef } from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import logo from '../../assets/img/Sculpt-logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { downloadBill, voucherData } from '../../redux/actions/Account.action';
import { appointementGetById } from '../../redux/actions/Files.action';
import { useState } from 'react';

const Index = ({ billRef, allData, id }) => {

    const billingId = localStorage.getItem('billingId')
    const historyId = localStorage.getItem('historyId')
    const [chargeName, setChargeName] = useState()
    const dispatch = useDispatch();
    const branchData = useSelector((state) => state.files)
    const billData = useSelector((state) => state.account)
    const fileCharges = billData?.getFileCharge?.data?.fileCharges
    const userId = branchData?.getAppointmentById?.data?.appointmentData?.patientId;
    const BillData = billData?.downloadBill?.data

    let downloadBills = billData?.downloadBill?.data
    let totalAmountBeforeTaxSum = 0;
    let totalSGSTSum = 0;
    let totalCGSTSum = 0;
    let totalTaxSum = 0;
    let totalAmountAfterTaxSum = 0;

    useEffect(() => {
        const payload = {
            billingId: billingId,
        }
        if (id) {
            dispatch(appointementGetById(id))
        }
        dispatch(downloadBill(userId, payload, id))
    }, [id, userId])

    useEffect(() => {
        if (fileCharges) {
            const fileChargeEntry = fileCharges.find((file) => file.fileName === 'File Charge');

            const consultantEntry = fileCharges.find((file) => file.fileName === 'Consultant');

            if (BillData?.type === 'FILECHARGE') {
                setChargeName(fileChargeEntry?.fileCharge);
            } else if (BillData?.type === 'CONSULTANT') {
                setChargeName(consultantEntry?.fileCharge);
            } else {
                setChargeName(null);
            }
        } else {
            console.log('fileCharges is undefined or null');
        }
    }, [fileCharges, BillData]);

    return (
        <div className='d-none'>
            <div
                ref={billRef}
                style={{
                    fontFamily: "Arial, sans-serif",
                    backgroundColor: "#fff",
                    width: '100%',
                    maxWidth: '595pt',
                    minHeight: "842pt",
                    overflow: 'hidden',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    margin: 'auto'
                }}
            >
                <div
                    style={{
                        width: "100%",
                        borderBottom: "1px solid #A0AEC0",
                        paddingBottom: "5px",
                        padding: "10mm",
                        height: "100px"
                    }}
                >
                    <div style={{ marginBottom: "10px" }}>
                        <img src={logo} alt="Sculpt logo" style={{ height: "100px" }} />
                    </div>
                </div>

                <div
                    style={{
                        flex: '1',
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "5mm 10mm",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            paddingLeft: "10px",
                            fontSize: "12px",
                        }}
                    >
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                                <p><strong>Patient Name : </strong> {downloadBills?.patientInfo?.firstName} {downloadBills?.patientInfo?.lastName}</p>
                                <p><strong>Dr. Name : </strong> {downloadBills?.patientInfo?.doctorName}</p>
                                <p><strong>State : </strong> {downloadBills?.patientInfo?.state || '-'}</p>
                            </div>
                            <div>
                                <p><strong>Sex : </strong> {downloadBills?.patientInfo?.gender}</p>
                                <p><strong>Ref By : </strong>  {downloadBills?.patientInfo?.reference[0]?.doctorDetail || downloadBills?.patientInfo?.reference[0]?.personDetail || ' - '}</p>
                                <p><strong>Contact No : </strong> {downloadBills?.patientInfo?.phoneNumber}</p>
                            </div>
                            <div>
                                <p><strong>Bill Number : </strong> {downloadBills?.consultantBillInfo?.billNumber}</p>
                                <p><strong>Bill Date : </strong>{new Date(downloadBills?.consultantBillInfo?.date).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}</p>
                            </div>
                        </div>
                        <hr style={{ color: "#d68000", fontWeight: "bold" }} />

                        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px', textAlign: 'center' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>SR. NO</th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>Date</th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>Treatment Name</th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>HSN/ Code</th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }} colSpan={5}>Total Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}></th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>{new Date(downloadBills?.consultantBillInfo?.date).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}</th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>{downloadBills?.consultantBillInfo?.type === 'FILECHARGE' && 'File Charge'}
                                        {downloadBills?.consultantBillInfo?.type === 'CONSULTANT' && 'Consultant'}
                                        {downloadBills?.consultantBillInfo?.type === 'SERVICE' && downloadBills?.consultantBillInfo?.serviceName}
                                        {downloadBills?.consultantBillInfo?.type === 'PACKAGE' && downloadBills?.consultantBillInfo?.packageName}</th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>9993</th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }} colSpan={5}>{billData?.downloadBill?.data?.totalAmount || billData?.downloadBill?.data?.consultantBillInfo?.serviceRate}</th>

                                </tr>
                                <tr>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}></th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}></th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}></th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}></th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>
                                        {
                                            downloadBills?.consultantBillInfo?.type === 'FILECHARGE' && 'File Charge Amount' ||
                                            downloadBills?.consultantBillInfo?.type === 'CONSULTANT' && 'Consultant Amount' ||
                                            downloadBills?.consultantBillInfo?.type === 'SERVICE' && 'Service Amount' ||
                                            downloadBills?.consultantBillInfo?.type === 'PACKAGE' && 'Package Amount'
                                        }
                                    </th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>Discount</th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>Recevied Amount</th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>Pending Amount</th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>Payment Type</th>
                                </tr>
                                {allData?.map((history, index) => {
                                    const totalAmountBeforeTax = parseFloat((history.amount / 1.18).toFixed(1)); // Convert to float after fixing decimals
                                    const sgst = parseFloat((totalAmountBeforeTax * 0.09).toFixed(1));
                                    const cgst = parseFloat((totalAmountBeforeTax * 0.09).toFixed(1));
                                    const totalTaxAmount = parseFloat((sgst + cgst).toFixed(1));
                                    const totalAmountAfterTax = parseFloat((totalAmountBeforeTax + totalTaxAmount).toFixed(1));

                                    totalAmountBeforeTaxSum += totalAmountBeforeTax;
                                    totalSGSTSum += sgst;
                                    totalCGSTSum += cgst;
                                    totalTaxSum += totalTaxAmount;
                                    totalAmountAfterTaxSum += totalAmountAfterTax;


                                    return (
                                        <>
                                            <tr key={index}>
                                                <td style={{ border: '1px solid gray', padding: '8px' }}>{index + 1}</td>
                                                <td style={{ border: '1px solid gray', padding: '8px' }}>{new Date(history?.paymentDate).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}</td>
                                                <td style={{ border: '1px solid gray', padding: '8px' }}>
                                                    {downloadBills?.consultantBillInfo?.type === 'FILECHARGE' && 'File Charge'}
                                                    {downloadBills?.consultantBillInfo?.type === 'CONSULTANT' && 'Consultant'}
                                                    {downloadBills?.consultantBillInfo?.type === 'SERVICE' && downloadBills?.consultantBillInfo?.serviceName}
                                                    {downloadBills?.consultantBillInfo?.type === 'PACKAGE' && downloadBills?.consultantBillInfo?.packageName}
                                                </td>
                                                <td style={{ border: '1px solid gray', padding: '8px' }}>

                                                    <td style={{ border: '1px solid gray', padding: '8px' }}>
                                                        {downloadBills?.consultantBillInfo?.type === 'FILECHARGE' || downloadBills?.consultantBillInfo?.type === 'CONSULTANT' ?
                                                            chargeName : downloadBills?.consultantBillInfo?.serviceRate}
                                                    </td>
                                                </td>
                                                <td style={{ border: '1px solid gray', padding: '8px' }}>
                                                    {(() => {
                                                        const { consultantBillInfo } = downloadBills || {};
                                                        const totalAmount =
                                                            consultantBillInfo?.type === 'FILECHARGE' || consultantBillInfo?.type === 'CONSULTANT'
                                                                ? parseInt(chargeName || 0)
                                                                : parseInt(consultantBillInfo?.serviceRate || 0);

                                                        const discountPercent =
                                                            parseFloat(
                                                                consultantBillInfo?.serviceDiscount ||
                                                                consultantBillInfo?.packageDiscount ||
                                                                consultantBillInfo?.filechargeDiscount ||
                                                                consultantBillInfo?.consultationDiscount ||
                                                                0
                                                            );

                                                        const discountFixed =
                                                            parseFloat(
                                                                consultantBillInfo?.serviceDiscountRs ||
                                                                consultantBillInfo?.packageDiscountRs ||
                                                                consultantBillInfo?.filechargeDiscountRs ||
                                                                consultantBillInfo?.consultationDiscountRs ||
                                                                0
                                                            );

                                                        let discountValue = 0;

                                                        // Calculate the discounted value based on percentage or fixed amount
                                                        if (discountPercent > 0) {
                                                            // Percentage-based discount
                                                            discountValue = (totalAmount * discountPercent) / 100;
                                                            return (
                                                                <>
                                                                    <p style={{ marginBottom: '0px' }}>{discountValue.toFixed(0)}</p> ({discountPercent}%)
                                                                </>
                                                            );
                                                        } else if (discountFixed > 0) {
                                                            // Fixed discount
                                                            discountValue = discountFixed;
                                                            return (
                                                                <>
                                                                    <p style={{ marginBottom: '0px' }}>{discountValue.toFixed(0)}</p> ({discountFixed}₹)
                                                                </>
                                                            );
                                                        } else {
                                                            return `-`;
                                                        }
                                                    })()}
                                                </td>

                                                <td style={{ border: '1px solid gray', padding: '8px' }}>
                                                    {history.amount}
                                                </td>
                                                <td style={{ border: '1px solid gray', padding: '8px' }}>
                                                    {history.remainAmount}
                                                </td>
                                                <td style={{ border: '1px solid gray', padding: '8px' }}>
                                                    {history.paymentMethod}
                                                </td>

                                            </tr>
                                        </>
                                    )
                                })}
                            </tbody>
                        </table>

                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                            <div style={{ marginTop: '20px', width: '60%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    {/* <div>
                                        <p style={{ margin: '0px' }}><strong>Payment Type:</strong> {downloadBills?.historyData?.length > 0 ? (
                                            downloadBills.historyData
                                                .map((history) => history.paymentMethod)
                                        ) : (
                                            ''
                                        )}</p>
                                    </div> */}
                                    <div>
                                        <p style={{ margin: '0px' }}><strong>Operator:</strong> {downloadBills?.authData}</p>
                                    </div>
                                </div>
                                <div style={{ marginTop: '10px' }}>
                                    <p><strong>Remark:</strong> {downloadBills?.patientInfo?.billRemark}</p>
                                </div>

                                <div>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px', textAlign: 'center' }}>
                                        <tr>
                                            <th style={{ border: '1px solid gray', padding: '5px' }} colSpan={2}>Bank Details</th>
                                        </tr>
                                        <tr>
                                            <th style={{ border: '1px solid gray', padding: '5px', textAlign: 'left' }}>Bank A/C </th>
                                            <td style={{ border: '1px solid gray', padding: '5px' }}>924020042078246</td>
                                        </tr>
                                        <tr>
                                            <th style={{ border: '1px solid gray', padding: '5px', textAlign: 'left' }}>Bank IFSC </th>
                                            <td style={{ border: '1px solid gray', padding: '5px' }}>UTIB0001772</td>
                                        </tr>
                                    </table>
                                    <p><strong>GST No : </strong> 24AFJFS8400C1Z9</p>
                                </div>
                            </div>
                            <div style={{ width: '40%' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px', textAlign: 'center' }}>
                                    <tr>
                                        <th style={{ border: '1px solid gray', padding: '5px', textAlign: 'left' }}>Total Amount Before Tax</th>
                                        <td style={{ border: '1px solid gray', padding: '5px' }}>{totalAmountBeforeTaxSum.toFixed(1)}</td>
                                    </tr>
                                    <tr>
                                        <th style={{ border: '1px solid gray', padding: '5px', textAlign: 'left' }}>CGST</th>
                                        <td style={{ border: '1px solid gray', padding: '5px' }}>{totalSGSTSum.toFixed(1)} (9%)</td>
                                    </tr>
                                    <tr>
                                        <th style={{ border: '1px solid gray', padding: '5px', textAlign: 'left' }}>SGST</th>
                                        <td style={{ border: '1px solid gray', padding: '5px' }}>{totalCGSTSum.toFixed(1)} (9%)</td>
                                    </tr>
                                    <tr>
                                        <th style={{ border: '1px solid gray', padding: '5px', textAlign: 'left' }}>Total Tax Amount</th>
                                        <td style={{ border: '1px solid gray', padding: '5px' }}>{totalTaxSum.toFixed(1)}</td>
                                    </tr>
                                    <tr>
                                        <th style={{ border: '1px solid gray', padding: '5px', textAlign: 'left' }}>Total Amount After Tax</th>
                                        <td style={{ border: '1px solid gray', padding: '5px' }}>{totalAmountAfterTaxSum.toFixed(1)}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>


                <div
                    style={{
                        position: 'fixed',
                        bottom: '0',
                        width: "100%",
                        borderTop: "5px solid #f2c07b",
                        // backgroundColor: '#b78234',
                        paddingLeft: "15px",
                        paddingRight: '15px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingBottom: "10px",
                        boxSizing: 'border-box',
                    }}
                >
                    <div style={{ marginTop: '10px' }}>
                        <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#f0cf9b' }}>Sculpt Skin Care</span>
                        <p style={{ fontSize: '16px', color: 'black', width: "300px" }}>
                            503, Swastik House, Kargil Chowk, Nr. Shardayatan School, Piplod, Surat, Gujarat 395007
                        </p>
                    </div>
                    <div style={{ marginTop: '15px', display: "grid" }}>
                        <p style={{ fontSize: "16px", color: "black", display: "flex", gap: '5px', marginBottom: "0px" }}>
                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#f0cf9b' }}>CALL: </span> +91 75750 96668
                        </p>
                        <p style={{ fontSize: "16px", color: "black", display: "flex", gap: '5px', marginBottom: "20px" }}>
                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#f0cf9b' }}>WEBSITE: </span> sculptskincare.in
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Index
